import { render, staticRenderFns } from "./vet-picker.vue?vue&type=template&id=0f65faa6&"
import script from "./vet-picker.vue?vue&type=script&lang=js&"
export * from "./vet-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports